// @ts-nocheck
import { Icons } from '@everlywell/leaves';
import { Link } from 'gatsby';
import React, { useEffect } from 'react';
import {
  USEFUL_LINKS,
  PATIENT_CARE_CENTER,
  MEDIA_INQUIRIES,
} from 'utils/constants/contactUs';
import { generateKey } from 'utils/helpers';

import * as S from './styles';

export interface IContactUsPage {
  usefulLinks: {
    url: string;
  }[];
  backgroundColor?: string;
}

export const ContactUsPage: React.FC = () => {
  useEffect(() => {
    // Load HubSpot forms script
    const script = document.createElement('script');
    script.src = '//js-na2.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.type = 'text/javascript';
    script.async = true;
    
    script.onload = () => {
      // Create form after script loads
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "243278056",
          formId: "adc88e86-5a0b-420f-a262-c1568cc9bce6",
          region: "na2",
          target: '#hubspot-form-container'
        });
      }
    };
    
    document.body.appendChild(script);
    
    // Cleanup script on unmount
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <S.SectionWrapper>
      <S.LeftPanel>
        <S.Container>
          {/* TODO: Make next 2 elements come from contentful */}
          <S.Row>
            <S.Headline>Contact Us</S.Headline>
          </S.Row>
          <S.Row>
            <S.Description>
              For clinical and test result inquiries related to Everlywell
              supportive services, please call {PATIENT_CARE_CENTER.phone} or send
              a message using the contact form found on our{' '}
              <Link to="/patients">Patient Inquiry</Link> page. If this is a
              healthcare emergency, please call 911.
            </S.Description>
          </S.Row>
          <S.HubSpotFormContainer id="hubspot-form-container" />
        </S.Container>
      </S.LeftPanel>
    <S.RightPanel>
      {/* {USEFUL LINKS} */}
      <S.SubTitle>USEFUL LINKS</S.SubTitle>
      <S.LinkList>
        {Object.entries(USEFUL_LINKS).map((item) => (
          <S.Link to={item[1]} key={generateKey()}>
            {item[0]}
            <S.IconWrapper>
              <Icons.RightArrow />
            </S.IconWrapper>
          </S.Link>
        ))}
      </S.LinkList>

      {/* {PATIENT CARE CENTER} */}
      <S.PatientWrapper>
        <S.SubTitle>{PATIENT_CARE_CENTER.name}</S.SubTitle>
        <S.SubHeadline>{PATIENT_CARE_CENTER.phone}</S.SubHeadline>
        <S.Content>{PATIENT_CARE_CENTER.content}</S.Content>
      </S.PatientWrapper>

      {/* {MEDIA INQUIRIES} */}
      <S.MediaWrapper>
        <S.SubTitle>{MEDIA_INQUIRIES.name}</S.SubTitle>
        <S.SubHeadline>{MEDIA_INQUIRIES.email}</S.SubHeadline>
      </S.MediaWrapper>
    </S.RightPanel>
  </S.SectionWrapper>
  );
};

export default ContactUsPage;
